/* Native radios own the choice. The script adds only a short, optional visual transition. */
(() => {
  const init = (scope = document) => scope.querySelectorAll('[data-pantry-choice]:not([data-motion-ready])').forEach(root => {
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let motion;
    root.addEventListener('change', event => {
      if (!event.target.matches('.j-pantry-choice__radio')) return;
      motion?.cancel();
      const panel = root.querySelector(`#${CSS.escape(event.target.getAttribute('aria-controls'))}`);
      if (panel && !reduced.matches) motion = panel.animate(
        [{opacity:.5, transform:'translateY(8px)'},{opacity:1, transform:'none'}],
        {duration:380, easing:'ease-out'}
      );
    });
    reduced.addEventListener('change', () => { if (reduced.matches) motion?.cancel(); });
    root.dataset.motionReady = 'true';
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true}); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
